import { inject, Injectable } from '@angular/core';
import { ServerDataService } from '@core/services/server-data/server-data.service';
import { AccessResponse, ProductType, Retailer } from '@root/app.interfaces';
import { Observable } from 'rxjs';

export interface OverviewReport extends AccessResponse {
	retailers: Retailer['id'][];
	origin: 'DYB-Embedded' | 'DYB';
	search: string;
	search_type: 'postcode';
	product_type: ProductType | 'all';
}

@Injectable({
	providedIn: 'root',
})
export class OverviewReportingService {
	serverDataService = inject(ServerDataService);

	sendReporting(report: OverviewReport): Observable<unknown> {
		return this.serverDataService.PostStatsData<OverviewReport>(report);
	}
}
